const mEditionAssetContentComments = {
  mEditionAssetContentComments: {
    loading: 'cargando datos',

    messages: {
      noComments: 'Sin comentarios',
      noQuestions: 'Sin preguntas',
      commentsAmount: {
        fisrtText: 'Mostrando',
        secondText: 'comentarios'
      },
      questionsAmount: {
        fisrtText: 'Mostrando',
        secondText: 'preguntas'
      }
    },

    submenu: {
      comments: 'Comentarios',
      questions: 'Preguntas'
    }
  }
}
export default mEditionAssetContentComments
